<template>
  <div class="pedidos-zona">
    <monitor-zona />
  </div>
</template>

<script>
import MonitorZona from '@/components/monitorZona/Monitor.vue'

export default {
  name: 'PedidosZona',
  components: {
    MonitorZona
  }
}
</script>
